import { useState, useEffect } from 'react';
import { getCountries, getStates } from '../../../apis/locationApi';

export function useCountryList({ enabled = true } = {}) {
  const [countries, setCountries] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCountries = async () => {
    setLoading(true);

    try {
      const result = await getCountries();
      if (!result.ok) {
        setError(result.originalError);
      }
      setCountries(result.data?.countries || []);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  const reset = () => {
    setCountries(null);
  }

  useEffect(() => {
    if (enabled) {
      fetchCountries();
    }
  }, [enabled]);

  return {
    countries,
    error,
    loading,
    fetchCountries,
    reset
  }
}

export function useStateList(countryToken, { enabled = true } = {}) {
  const [states, setStates] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchStates = async (token) => {
    setLoading(true);

    try {
      const result = await getStates({ countryToken: token });
      if (!result.ok) {
        setError(result.originalError);
      }
      setStates(result.data?.states || []);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  const reset = () => {
    setStates(null);
  }


  useEffect(() => {
    if (countryToken && enabled) {
      fetchStates(countryToken);
    }
  }, [countryToken, enabled]);

  return {
    states,
    error,
    loading,
    fetchStates,
    reset
  }
}



